{
  "pages": {
    "hubTitle": "Tăng ca",
    "tabsAria": "Tab tăng ca",
    "tabs": {
      "requests": "Đơn tăng ca",
      "types": "Loại tăng ca"
    },
    "permissionDenied": "Bạn không có quyền xem tăng ca."
  },
  "fields": {
    "status": "Trạng thái",
    "code": "Mã",
    "name": "Tên loại",
    "color": "Màu",
    "multiplier": "Hệ số",
    "sortOrder": "Thứ tự",
    "date": "Ngày",
    "startTime": "Giờ bắt đầu",
    "endTime": "Giờ kết thúc",
    "window": "Khung giờ",
    "minutes": "Thời lượng",
    "type": "Loại tăng ca",
    "clinic": "Chi nhánh",
    "reason": "Lý do",
    "requester": "Người xin",
    "approvers": "Người duyệt",
    "approversEmpty": "Chưa cấu hình người duyệt chấm công trên hồ sơ",
    "approversHint": "Dùng cùng danh sách duyệt chấm công trên hồ sơ nhân viên / phòng ban.",
    "approversSetup": "Thiết lập người duyệt trên hồ sơ",
    "approversSetupReadonly": "Chưa có người duyệt trên hồ sơ hoặc phòng ban.",
    "rejectionReason": "Lý do từ chối",
    "reviewedBy": "Người xử lý",
    "reviewedAt": "Ngày xử lý",
    "createdAt": "Ngày tạo",
    "createdBy": "Người tạo",
    "updatedBy": "Người sửa",
    "updatedAt": "Ngày chỉnh sửa"
  },
  "placeholders": {
    "code": "Ví dụ: SURGERY",
    "name": "Ví dụ: OT phẫu thuật",
    "multiplier": "Ví dụ: 1.5",
    "sortOrder": "Ví dụ: 0",
    "reason": "Lý do tăng ca",
    "searchRequests": "Tìm theo tên, lý do…",
    "searchTypes": "Tìm loại tăng ca…",
    "selectStatus": "Chọn trạng thái",
    "selectStaff": "Chọn nhân viên",
    "selectClinic": "Chọn chi nhánh",
    "selectType": "Chọn loại tăng ca",
    "dateRange": "Chọn khoảng ngày"
  },
  "filters": {
    "all": "Tất cả",
    "trigger": "Bộ lọc",
    "requestsTitle": "Lọc đơn tăng ca",
    "clearAll": "Xóa tất cả",
    "apply": "Áp dụng",
    "dateRange": "Khoảng ngày",
    "dateRangePlaceholder": "Chọn khoảng ngày",
    "selectStatus": "Chọn trạng thái",
    "typesTitle": "Lọc loại tăng ca",
    "allStatuses": "Tất cả trạng thái",
    "allStaff": "Tất cả nhân viên"
  },
  "status": {
    "active": "Đang dùng",
    "inactive": "Ngừng dùng",
    "pending": "Chờ duyệt",
    "approved": "Đã duyệt",
    "rejected": "Từ chối",
    "cancelled": "Đã hủy"
  },
    "actions": {
      "addType": "Thêm loại",
      "createRequest": "Đơn tăng ca",
      "submitRequest": "Tạo đơn",
      "approve": "Duyệt",
      "reject": "Từ chối",
      "cancel": "Hủy đơn",
      "moreActions": "Thao tác",
      "viewDetails": "Chi tiết",
      "history": "Lịch sử"
    },
  "dialogs": {
    "addType": "Thêm loại tăng ca",
    "editType": "Sửa loại tăng ca",
    "createRequest": "Tạo đơn tăng ca"
  },
  "table": {
    "type": "Loại",
    "multiplier": "Hệ số",
    "status": "Trạng thái"
  },
  "requests": {
    "empty": "Chưa có đơn tăng ca.",
    "searchPlaceholder": "Tìm theo tên, lý do…",
    "historyTitle": "Lịch sử đơn tăng ca",
    "historyEmpty": "Chưa có lịch sử thay đổi cho đơn này.",
    "detailsTitle": "Chi tiết đơn tăng ca",
    "createTitle": "Xin tăng ca",
    "status": {
      "pending": "Chờ duyệt",
      "approved": "Đã duyệt",
      "rejected": "Từ chối",
      "cancelled": "Đã hủy"
    },
    "toasts": {
      "loadFailed": "Không tải được đơn tăng ca.",
      "createSuccess": "Đã gửi đơn tăng ca.",
      "createFailed": "Không gửi được đơn tăng ca.",
      "approveSuccess": "Đã duyệt đơn tăng ca.",
      "approveFailed": "Không duyệt được đơn.",
      "rejectSuccess": "Đã từ chối đơn tăng ca.",
      "rejectFailed": "Không từ chối được đơn.",
      "cancelSuccess": "Đã hủy đơn tăng ca.",
      "cancelFailed": "Không hủy được đơn."
    },
    "validation": {
      "dateRequired": "Chọn ngày.",
      "startRequired": "Chọn giờ bắt đầu.",
      "endRequired": "Chọn giờ kết thúc.",
      "endAfterStart": "Giờ kết thúc phải sau giờ bắt đầu.",
      "clinicRequired": "Chọn chi nhánh.",
      "typeRequired": "Chọn loại tăng ca.",
      "reasonRequired": "Nhập lý do."
    }
  },
  "types": {
    "empty": "Chưa có loại tăng ca.",
    "emptyFiltered": "Không tìm thấy loại tăng ca.",
    "historyTitle": "Lịch sử loại tăng ca",
    "historyEmpty": "Chưa có lịch sử thay đổi cho loại này.",
    "toasts": {
      "loadFailed": "Không tải được loại tăng ca.",
      "created": "Đã tạo loại tăng ca.",
      "updated": "Đã cập nhật loại tăng ca.",
      "saveFailed": "Không lưu được loại tăng ca.",
      "statusUpdated": "Đã đổi trạng thái loại tăng ca.",
      "statusFailed": "Không đổi được trạng thái."
    },
    "validation": {
      "required": "Nhập mã và tên loại.",
      "multiplierRequired": "Nhập hệ số.",
      "multiplierRange": "Hệ số từ 1 đến 5.",
      "sortOrder": "Thứ tự phải là số nguyên."
    }
  },
  "toasts": {
    "loadStaffFailed": "Không tải được danh sách nhân viên.",
    "loadClinicsFailed": "Không tải được danh sách chi nhánh."
  },
  "errors": {
    "ATTENDANCE_MONTH_LOCKED": "Bảng công tháng đã khóa, không tạo hoặc duyệt đơn tăng ca được.",
    "OVERTIME_APPROVER_REQUIRED": "Cần cấu hình người duyệt chấm công trên hồ sơ nhân viên hoặc phòng ban trước khi gửi đơn.",
    "NOT_ATTENDANCE_APPROVER": "Bạn không phải người duyệt đơn này."
  }
}
